<template>
  <Card>
    <h1 slot="Title">Army Financial Management & Comptroller (Cont.)</h1>
    <div slot="MainContent">
      <p><b>DFAS-IN Manual 37-100</b></p>
      <ul>
        <li>
          Establishes standard codes and terms for classifying financial resource transactions under applicable public law.
          
        </li>
        <li>
          Establishes the Standard Army Accounting Classification.

        </li>
        <li>
          Establishes the level of detail and frequency for accounting and reporting of financial data. 

        </li>
        <li>
          Prescribes performance factors for organizations and functions.

        </li>
        <li>
          Will be published and updated through electronic message 

        </li>
        <li>
          Changes and chapter replacement. A fresh baseline will be created annually.

        </li>
      </ul>
    </div>
    <div slot="Notes">
      <p style="line-height:normal;margin-top:4.32pt;margin-bottom:0pt;margin-left:0in;margin-right:0in;text-indent:0in;text-align:left;vertical-align:baseline;"><span style="font-size: 16px; font-family: Calibri; color: rgb(255, 255, 255); font-weight: bold;">Army Financial Management &amp; Comptroller (Cont.)</span></p>
      <p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="color: rgb(255, 255, 255);"><span style="font-size: 16px; font-family: Arial; font-weight: bold;">Army Management Structure (Federated ERPs) Guide &nbsp;&nbsp;</span><span style="font-size: 16px; font-family: Calibri;">-&nbsp;</span><span style="font-size: 16px; font-family: Arial;">This guide provides users essential information about the Master Data Elements used by the Army&rsquo;s Federated Enterprise Resource Planning (ERP) Business Systems. With this edition, we have begun to expand the scope of the guide to cover master data for all Federated ERP Business&nbsp;Systems, and&nbsp;changed its name from &ldquo;Army Funds Management Data Reference Guide&rdquo; to its new name to reflect its applicability to all Army Federated ERP Business Systems.</span></span></p>
      <p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="color: rgb(255, 255, 255);"><span style="font-size: 16px; font-family: Arial; font-weight: bold;">Army Federated Enterprise Resource Planning Business Systems:&nbsp;</span></span></p>
      <div style="margin-top:0pt;margin-bottom:0pt;margin-left:.19in;text-indent:-.19in;text-align:left;"><span style="color: rgb(255, 255, 255);"><span style="font-size:16px;"><span style="font-family:Arial;">&bull;</span></span><span style="font-size: 16px; font-family: Arial; font-weight: normal;">General Fund Enterprise Business System (GFEBS)</span></span></div>
      <div style="margin-top:0pt;margin-bottom:0pt;margin-left:.19in;text-indent:-.19in;text-align:left;"><span style="color: rgb(255, 255, 255);"><span style="font-size:16px;"><span style="font-family:Arial;">&bull;</span></span><span style="font-size: 16px; font-family: Arial; font-weight: normal;">Global Combat Support System-Army (GCSS-Army)</span></span></div>
      <div style="margin-top:0pt;margin-bottom:0pt;margin-left:.19in;text-indent:-.19in;text-align:left;"><span style="color: rgb(255, 255, 255);"><span style="font-size:16px;"><span style="font-family:Arial;">&bull;</span></span><span style="font-size: 16px; font-family: Arial; font-weight: normal;">Logistics Modernization Program (LMP)</span></span></div>
      <p style="margin-top:0pt;margin-bottom:0pt;margin-left:0in;text-align:left;"><span style="font-size: 16px; font-family: Arial; color: rgb(255, 255, 255);">This guide is a companion to DFAS-IN Manual 37-100, The Army Management Structure.</span></p>
    </div>
  </Card>
</template>

<style scoped>
.ThreeWrapper {
  width: 100%;
  margin-bottom: 32px;
}
</style>

<script>
import Card from '../../../components/Card.vue';

export default {

  components: {
    Card
  },
  name: 'ArmyFinancialManagementComptrollerCont',
  
  data() {
    return {
    }
  }
  
}
</script>